import PropTypes from 'prop-types';
import React from 'react';

class Popover extends React.Component {
    static propTypes = {
        children: PropTypes.element.isRequired,
        header: PropTypes.element,
    };

    renderHeader = () => {
        if (this.props.header) {
            return this.props.header;
        }

        return (
            <header>
                <button data-highlight="" className="close">
                    ×
                </button>
            </header>
        );
    };

    render() {
        const popoverStyle = {
            // top: "673.4375px",
            // left: "652.7421875px",
            display: 'block',
            position: 'static',
        };

        // popover fade bottom in
        return (
            <div style={popoverStyle}>
                <div className="arrow" />
                <div className="popover-content">{this.props.children}</div>
            </div>
        );
    }
}

export default Popover;



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/popover.jsx